/**
 * AddGeoBlockingCtrl controller
 * Show general settings
 */

import { ACL_MODE_TYPES, ACL_TYPES, GET_COUNTRIES } from 'app/core/constants'
import { inputIPV4AndV6Validator } from '../../app/helpers/validators'

// AddGeoBlockingCtrl mixins
AddGeoBlockingCtrl.mixes = [
  ['m2mCtrlMixin', 'acl', 'networks']
]

/**
 * AddGeoBlockingCtrl controller
 *
 * @class AddGeoBlockingCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddGeoBlockingCtrl
 */
/* @ngInject */
export default function AddGeoBlockingCtrl ($scope, $location, $timeout, $uibModal, Network, Acl, acl, inapp) {
  var vm = this
  vm.customNetworkValidators = inputIPV4AndV6Validator
  vm.isNew = acl._isNew()

  vm.tags = []

  GET_COUNTRIES().to(vm.countries = [])

  vm.isNew = $location.$$path.indexOf('new') > -1

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:AddGeoBlockingCtrl
   * @type {number}
   */
  vm.inappNetwork = inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network

  /**
   * Default Package for guest mode
   *
   * @memberof mwApp/packages.controller:AddGeoBlockingCtrl
   * @type {number}
   */
  vm.guestNetwork = inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network

  /**
   * ACLs intersections and permission popup
   *
   * @memberof mwApp/aclList.controller:AddGeoBlockingCtrl
   * @function
   */
  vm.aclsIntersections = function (list) {
    $uibModal.open({
      templateUrl: 'components/acls/views/aclsIntersections.html',
      controller: 'AclsIntersections as vm',
      animation: false,
      size: 'lg',
      resolve: {
        list: function () {
          return list
        }
      }
    })
  }

  /**
   * @description Additional form validation
   */
  vm.validation = function () {
    if (vm.acl.aclType === 'PACKAGE' && vm.acl.networks.length === 0) {
      return false
    }
    return true
  }

  /**
   * Constant with mod types
   *
   * @type {Object}
   */
  vm.acl_mode_types = ACL_MODE_TYPES

  /**
   * Constant with types
   *
   * @type {Object}
   */
  vm.acl_types = ACL_TYPES

  /**
   * @description checking acl.networks list for inappNetwork
   *
   * @returns {boolean}
   */
  vm.isInappSelected = function () {
    return !!vm.acl.networks.find(({ id }) => id === vm.inappNetwork.id)
  }

  /**
   * @description checking acl.networks list for guest mode
   *
   * @returns {boolean}
   */
  vm.isGuestSelected = function () {
    return !!vm.acl.networks.find(({ id }) => id === vm.guestNetwork.id)
  }

  /**
   * Tag transformer for custom select value
   *
   * @param newTag
   * @return {{value : String}}
   */
  vm.tagTransform = function (newTag) {
    return {
      value: newTag
    }
  }

  /**
   * Load all available networks
   */
  Network.loadAll('?count=true')
    .then(allNetworks => allNetworks.filter(allNetwork => !vm.acl.networks.find(selectedNetwork => allNetwork.id === selectedNetwork.id)))
    .to(vm.networks = [])

  /**
   * Load data acls
   */
  if (vm.isNew) {
    $scope.loading = false
    vm.acl = new Acl()
  } else {
    vm.acl = acl
  }

  /**
   * Save configuration acls
   *
   * @memberof mwApp/settings.controller:AddGeoBlockingCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    vm.acl._save()
      .then(() => {
        vm.unsetDisable()
        $location.url('geoblocking')
      })
      .catch((error) => {
        if (error.newData) {
          vm.aclsIntersections(error.newData)
        }
        vm.unsetDisable()
      })
  }

  vm.delete = function () {
    acl._delete().then(() => {
      $location.url('geoblocking')
    })
  }
}
